import AddModulesStep from "./AddModulesStep";
import CollectionCreationResultStep from "./CollectionCreationResultStep";
import CollectionDetailsStep from "./CollectionDetailsStep";
import ReviewCollectionChangesStep from "./ReviewCollectionChangesStep";


const CollectionCreatorSteps = ({ allVideos, authorsDict, collection, createdModules, currentStep, currentUser, goToNextStep, goToPreviousStep, modules, setUserCreatedModules, updateState, videoBank }) => {
    if(currentStep === 0){
        return  <CollectionDetailsStep 
                    authorsDict={authorsDict}
                    collection={collection} 
                    currentUser={currentUser}
                    goToNextStep={goToNextStep} 
                    updateState={updateState}
                />
    } else if(currentStep == 1) {
        return  <AddModulesStep 
                    allVideos={allVideos}
                    authorsDict={authorsDict}
                    collection={collection} 
                    createdModules={createdModules}
                    currentUser={currentUser}
                    goToNextStep={goToNextStep} 
                    goToPreviousStep={goToPreviousStep} 
                    modules={modules}
                    setUserCreatedModules={setUserCreatedModules}
                    updateState={updateState}
                    videoBank={videoBank}
                />
    } else if(currentStep == 2) {
        return  <ReviewCollectionChangesStep
                    authorsDict={authorsDict}
                    collection={collection} 
                    currentUser={currentUser}
                    modules={modules}
                    goToNextStep={goToNextStep} 
                    goToPreviousStep={goToPreviousStep} 
                />
    } else if(currentStep == 3) {
        return  <CollectionCreationResultStep 
                    goToPreviousStep={goToPreviousStep} 
                />
    }
}

export default CollectionCreatorSteps;